// extracted by mini-css-extract-plugin
export default {"content":"PortfolioInfo_content__Yr7ef","value":"PortfolioInfo_value__PacgA"};